<template>
  <div>
    <Skeleton
      height="3rem"
      width="198px"
      :style="{ 'margin-bottom': '4rem' }"
    />
    <Skeleton
      width="100%"
      height="auto"
      :style="{ padding: '0.5rem' }"
      v-for="i in 10"
      :key="i"
    >
      <Skeleton
        color="#E3E3E3"
        height="64px"
        width="64px"
        :style="{ 'margin-bottom': 0 }"
      />
    </Skeleton>
  </div>
</template>
<script>
export default {
  components: {
    Skeleton: () => import('@/components/Universal/Skeleton')
  }
}
</script>
